/**
 * 3-state filter pill for admin lists: Active / Archived / All.
 *
 * Persists per `storageKey` in localStorage so admins don't lose state
 * when reloading.
 */
import { useEffect, useState } from "react";
import { Filter } from "lucide-react";

const OPTIONS = [
  { value: "active",   label: "Active" },
  { value: "archived", label: "Archived" },
  { value: "all",      label: "All" },
];

export function useArchiveFilter(storageKey = "admin.archiveFilter", defaultValue = "active") {
  const [value, setValue] = useState(() => {
    try {
      return localStorage.getItem(storageKey) || defaultValue;
    } catch {
      return defaultValue;
    }
  });
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, value);
    } catch {
      /* ignore */
    }
  }, [value, storageKey]);
  return [value, setValue];
}

export function ArchiveStatusFilter({ value, onChange, testId = "archive-filter" }) {
  return (
    <div data-testid={testId} className="inline-flex items-center gap-1 rounded-full border border-slate-200 bg-white p-1 shadow-sm">
      <Filter className="w-3.5 h-3.5 text-slate-400 ml-2" />
      {OPTIONS.map((opt) => (
        <button
          type="button"
          key={opt.value}
          data-testid={`${testId}-${opt.value}`}
          onClick={() => onChange(opt.value)}
          className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            value === opt.value
              ? "bg-slate-900 text-white"
              : "text-slate-600 hover:text-slate-900"
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export default ArchiveStatusFilter;
